export default "__VITE_ASSET__CGkcK0Bh__"